import { render, staticRenderFns } from "./infoBottom.vue?vue&type=template&id=09331483&"
import script from "./infoBottom.vue?vue&type=script&lang=ts&"
export * from "./infoBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports